import styled from "styled-components";
import { Icon, RowView2 } from "../../../Component/style/common_style";
import Layout_user from "../../../Component/UI/Layout_user";
import TopBar from "../../../Component/UI/TopBar";
import { useNavigate } from "react-router-dom";

const AdminSign = () => {
  const Navigate = useNavigate();
  const goAdminSignUp = () => {
    Navigate("/admin/adminsignup");
  };

  return (
    <Layout_user>
      <TopBar title="입점" />
      <MenuList>
        <RowView2 onClick={goAdminSignUp} style={{ cursor: "pointer" }}>
          <Icon
            src={require("../../../Image/ic_chat_white.png")}
            style={{ marginRight: 5 }}
          />
          신청하기
        </RowView2>
      </MenuList>
    </Layout_user>
  );
};

export default AdminSign;

const MenuList = styled.div`
  padding: 12px 24px;
  font-family: var(--font-Pretendard-SemiBold);
  font-size: 16px;
`;
